import { useState } from "react";
import { NavLink, Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="bg-gray-200 text-black shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo / Brand */}
        <Link
          to="/"
          className="text-xl font-bold tracking-wide flex items-center gap-2"
        >
          <img
            src="/assets/images/avon_logo.png" // Replace with your actual image filename
            alt="Avon Tools Logo"
            className="h-16 w-auto"
          />
        </Link>
        {/* Spacer for alignment, can be removed or replaced with additional elements if needed */}
        <div className="flex-1"></div>
        {/* Desktop Menu */}
        <div className="hidden md:flex gap-6 items-center">
          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive
                ? "text-navy font-semibold transition"
                : "hover:text-navy transition"
            }
            end
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive
                ? "text-navy font-semibold transition"
                : "hover:text-navy transition"
            }
          >
            About
          </NavLink>
          <NavLink
            to="/products"
            className={({ isActive }) =>
              isActive
                ? "text-navy font-semibold transition"
                : "hover:text-navy transition"
            }
          >
            Products
          </NavLink>
          <NavLink
            to="/fasteners"
            className={({ isActive }) =>
              isActive
                ? "text-navy font-semibold transition"
                : "hover:text-navy transition"
            }
          >
            Fasteners
          </NavLink>
          <NavLink
            to="/process"
            className={({ isActive }) =>
              isActive
                ? "text-navy font-semibold transition"
                : "hover:text-navy transition"
            }
          >
            Process
          </NavLink>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive
                ? "text-navy font-semibold transition"
                : "hover:text-navy transition"
            }
          >
            Contact
          </NavLink>
          <a
            href="/Avon_Tools_Brochure.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-3 bg-navy hover:bg-navy-dark text-white px-4 py-2 rounded transition"
          >
            Download Brochure
          </a>
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden">
          <button onClick={toggleMenu} className="text-2xl focus:outline-none">
            ☰
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden px-4 pb-4 bg-gray-100 text-black space-y-3">
          <Link to="/" onClick={toggleMenu} className="block hover:text-navy">
            Home
          </Link>
          <Link
            to="/about"
            onClick={toggleMenu}
            className="block hover:text-navy"
          >
            About
          </Link>
          <Link
            to="/products"
            onClick={toggleMenu}
            className="block hover:text-navy"
          >
            Products
          </Link>
          <Link
            to="/fasteners"
            onClick={toggleMenu}
            className="block hover:text-navy"
          >
            Fasteners
          </Link>
          <Link
            to="/process"
            onClick={toggleMenu}
            className="block hover:text-navy"
          >
            Process
          </Link>
          <Link
            to="/contact"
            onClick={toggleMenu}
            className="block hover:text-navy"
          >
            Contact
          </Link>
          <a
            href="/Avon_Tools_Brochure.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-navy hover:bg-navy-dark text-white text-center px-4 py-2 rounded"
          >
            Download Brochure
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
